import { useState } from 'react';
import { Button } from 'primereact/button';
import { useCellEditing } from '../../../../../shared/hooks/CellEditing';
import { generateId } from '../../../../../utils/generateId';
import moment from 'moment';

const formatDateOrText = (value: any) => {
  const m = moment(value);
  return m.isValid() ? m.format('DD/MM/YYYY') : value;
};

export const EInvoiceSuspensionRequest = ({ items, setItems, options, tokens }) => {
  const [filteredOptions, setFilteredOptions] = useState(options);

  const tokenDropdownOptions = [
    {
      value: '__header__',
      isHeader: true,
      venderShortcut: 'Nhà cung cấp',
      serialNumber: 'Số sê-ri chứng thư',
      dateFrom: 'Ngày hiệu lực',
      expireDate: 'Ngày hết hạn'
    },
    ...tokens.map((t) => ({
      ...t,
      value: t.serialNumber
    }))
  ];
  const { render: renderEditing, selectedItem: editingItem, setSelectedItem: setEditingItem } = useCellEditing({
    dataKey: 'id',
    columns: [
      {
        field: 'index', header: 'STT', style: { textAlign: 'center' }, dataType: 'custom', customCell(rowData: any, rowIndex): any {
          return rowIndex + 1;
        }
      },
      { field: 'fromDate', header: 'Ngày bắt đầu ngừng sử dụng', editable: true, dataType: 'date', style: { minWidth: '100px', maxWidth: '100px' } },
      { field: 'toDate', header: 'Ngày kết thúc ngừng sử dụng', editable: true, dataType: 'date', style: { minWidth: '100px', maxWidth: '100px' } },
      {
        field: 'providerName',
        header: 'Tên đơn vị cung cấp dịch vụ hóa đơn',
        dataType: "autocomplete",
        editable: true,
        style: { minWidth: '170px' },
        maxLength: 400,
        inputProps: {
          field: 'partnerName',
          suggestions: filteredOptions,
          completeMethod: (event) => {
            const query = event.query.toLowerCase();
            const filtered = options.filter((item) => item.partnerName.toLowerCase().includes(query));
            setFilteredOptions(filtered);
          },
          itemTemplate: (item) => {
            return item.partnerName;
          }
        }
      },
      { field: 'providerTaxCode', header: 'Mã số thuế', editable: true, style: { minWidth: '200px' }, maxLength: 14 },
      {
        field: 'providerSerialNumber',
        header: 'Số sê-ri chứng thư',
        dataType: "dropdown",
        editable: true,
        style: { minWidth: '160px', maxWidth: '160px' },
        maxLength: 40,
        inputProps: {
          showClear: true,
          options: tokenDropdownOptions,
          optionDisabled: (opt) => opt.isHeader,
          panelStyle: { width: '700px' },
          optionValue: 'value',
          optionLabel: 'serialNumber',
          itemTemplate: (item) => {
            const isHeader = item.isHeader;
            return <div
              className="grid w-full text-sm py-2"
              style={isHeader ? { fontWeight: 600, borderBottom: '1px solid #dee2e6', backgroundColor: '#f8f9fa' } : {}}
            >
              <div className="col-2" style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>{item.venderShortcut}</div>
              <div className="col-4" style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>{item.serialNumber}</div>
              <div className="col-3">{formatDateOrText(item.dateFrom)}</div>
              <div className="col-3">{formatDateOrText(item.expireDate)}</div>
            </div>;
          }
        },
      },
      {
        field: 'note', header: 'Ghi chú', editable: true, style: { minWidth: '170px' }, maxLength: 255
      }
    ],
    items: items,
    onCellChange: (rowData, column, newValue) => {
      const _items = [...items];
      for (const _item of _items) {
        if (_item.id === rowData.id) {
          if (column.field === 'providerName') {
            const selectedOption = options.find(option => option.partnerName === newValue.partnerName);
            if (selectedOption) {
              _item['providerName'] = selectedOption.partnerName || '';
              _item['providerTaxCode'] = selectedOption.partnerTaxCode || '';
              // _item['providerSerialNumber'] = selectedOption.providerSerialNumber || '';
              break;
            }
          }
          _item[column.field] = newValue;
        }
      }
      setItems(_items);
    }
  });

  const deleteToken = () => {
    if (editingItem) {
      const _items = items.filter((f) => f.id !== editingItem.id);
      setItems(_items);
      setEditingItem(null);
    }
  }

  return (
    <div className="grid">
      <div className="mb-1 col-12 un-fluid">
        <Button label="Thêm" className="p-button-outlined p-button-success p-button-sm mr-2" onClick={(event) => setItems([...items, { id: generateId() }])} />
        <Button label="Xoá" className="p-button-outlined p-button-danger p-button-sm" onClick={deleteToken} disabled={!editingItem} />
      </div>
      <div className="col-12">
        {renderEditing()}
      </div>
    </div>
  );
}